import { setupUi } from '@payjib/ui'
import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { initAuth } from '@/composables/useAuth'

import App from './App.vue'
import router from './router/index.ts'
import './assets/css/main.css'
import DatePicker from '@alireza-ab/vue3-persian-datepicker'
import VueApexCharts from 'vue3-apexcharts'
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import * as components from '@/components'
import { initVersionCheck } from '@/composables/useVersionCheck'
import { setupVueQuery } from '@/plugins/vue-query'
import { setupReCaptcha } from './plugins/recaptcha.ts'

async function bootstrap() {
  const app = createApp(App)

  Sentry.init({
    app,
    dsn: 'https://7f0516c20285600cb756ae3ea57808c2@sentry.hamravesh.com/10651',
  })

  setupVueQuery(app)
  setupReCaptcha(app)
  setupUi(app)

  Object.entries(components).forEach(([name, component]) => {
    app.component(name, component)
  })

  app.component('Vue3PersianDatetimePicker', Vue3PersianDatetimePicker)
  app.component('alireza-date-picker', DatePicker)
  app.use(VueApexCharts)
  app.use(createPinia())

  app.use(router)

  initAuth()
  initVersionCheck()

  app.mount('#app')
}
bootstrap()
